import React from 'react';
import { Dropdown, Menu,  } from 'antd';
import {
  FileTextOutlined,
  UploadOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  CaretDownOutlined,
  DownCircleOutlined,
  CheckSquareOutlined,
  MailOutlined,
  NumberOutlined,
} from '@ant-design/icons';
import { BsRecordCircle } from 'react-icons/bs';
import { MdOutlineSort } from 'react-icons/md';

const questionTypes = [
  { key: 'text', label: 'Réponse courte', icon: <MdOutlineSort /> },
  { key: 'textarea', label: 'Paragraphe', icon: <FileTextOutlined /> },
  { key: 'radio', label: 'Choix unique', icon: <BsRecordCircle /> },
  { key: 'checkbox', label: 'Cases à cocher', icon: <CheckSquareOutlined /> },
  { key: 'select', label: 'Liste déroulante', icon: <DownCircleOutlined /> },
  { key: 'file', label: 'Importer un fichier', icon: <UploadOutlined /> },
  { key: 'date', label: 'Date', icon: <CalendarOutlined /> },
  { key: 'time', label: 'Heure', icon: <ClockCircleOutlined /> },
  { key: 'email', label: 'Email', icon: <MailOutlined /> },
  { key: 'number', label: 'Nombre', icon: <NumberOutlined /> },

];

const AddQuestionButton = ({ onAdd }) => {
  const menu = (
    <Menu onClick={({ key }) => onAdd(key)}>
      {questionTypes.map(({ key, label, icon }) => (
        <Menu.Item key={key} icon={icon}>
          {label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
        <CaretDownOutlined  style={{fontSize:"18px"}}/>
      </Dropdown>
    </>
  );
};

export default AddQuestionButton;
